/**
 * UI overhaul PR-1a — per-tab scroll offsets for this browser session.
 *
 * Each tab pane is its own scroll container (TabsHost). A `display:none` box
 * forgets its scroll position, so the pane writes its offset here on every
 * scroll and reads it back the moment it becomes visible again. Not
 * persisted: a reload starts every page at the top, and a tab that was
 * unloaded (outside the live set) starts at the top when it re-renders.
 */
const offsets = new Map<string, number>()

export function rememberScroll(tabId: string, scrollTop: number): void {
  offsets.set(tabId, scrollTop)
}

export function recallScroll(tabId: string): number {
  return offsets.get(tabId) ?? 0
}

export function forgetScroll(tabId: string): void {
  offsets.delete(tabId)
}
